export const navData = [
  {
    name: 'HOME',
    path: '/',
    number: '00',
  },
  {
    name: 'DESTINATION',
    path: '/destination',
    number: '01',
  },
  {
    name: 'CREW',
    path: '/crew',
    number: '02',
  },
  {
    name: 'TECHNOLOGY',
    path: '/technology',
    number: '03',
  }
]